import AdvanceTextEditor from './AdvanceTextEditor';

export default AdvanceTextEditor;
